import React from 'react';
import Loader from 'react-loader-spinner';

export default () => (
  <div className='loader-container'>
    <Loader type='Oval' color='#37BEC3' height={50} width={50} />
  </div>
);
